import React, { useEffect } from 'react'
import { reduxForm, Field, formValueSelector } from 'redux-form'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { connect } from 'react-redux'

import { SelectField, InputField } from '../../../components/inputs'
import TrimOptions from './trimOptions'
import TrimLevel from './trimLevel'
import { Vehicle } from '../../../core/types'
import { updateSelectedTrim } from '../../refiApp/vehicle/vehicleActions'

export type Callback<T = void> = (...args: any) => T

const mileageMask = createNumberMask({
  prefix: '',
})

export interface Props {
  vehicle: Vehicle
  selectedTrimId: string
  controls: Callback
  updateSelectedTrim: Callback
}

export interface FormProps {
  mileage: string
}

export const VehicleDetailsForm = (props) => {
  const {
    handleSubmit,
    submitting,
    vehicle,
    selectedTrimId,
    controls,
    updateSelectedTrim,
  } = props

  useEffect(() => {
    updateSelectedTrim(vehicle, selectedTrimId)
  }, [selectedTrimId])

  if (!selectedTrimId) {
    return null
  }

  return (
    <form className="form" name="VehicleDetailForm" onSubmit={handleSubmit}>
      <div
        className="form__grid"
        // disabled={submitting} // TODO-TS
      >
        <div>
          <Field<any> // TODO-TS
            type="text"
            label="Current Mileage"
            name="mileage"
            component={InputField}
            mask={mileageMask}
            aria-required="true"
          />

          <TrimLevel vehicle={vehicle} />
        </div>

        <div>
          <Field<any>
            label="Condition"
            name="condition"
            component={SelectField}
            aria-required="true"
          >
            <option value="CLEAN">Clean</option>
            <option value="AVERAGE">Good</option>
            <option value="ROUGH">Rough</option>
          </Field>

          <Field<any>
            label="Transmission"
            name="transmission"
            component={SelectField}
            aria-required="true"
          >
            <option value="AUTOMATIC">Automatic</option>
            <option value="MANUAL">Manual</option>
            <option value="NA">Not applicable</option>
          </Field>
        </div>

        <div className="form__grid__section">
          <h2 className="input-group__header">Trim Options</h2>
          <hr className="form__hr  form__hr--margin-top" />
          <TrimOptions vehicle={vehicle} selectedTrimId={selectedTrimId} />
        </div>
      </div>
      {controls(submitting, vehicle.id)}
    </form>
  )
}

export const validate = (data) => {
  const { mileage } = data
  const errors: Partial<FormProps> = {}

  if (!mileage) {
    errors.mileage = 'Mileage is required'
  }

  return errors
}

// Keep drafts on unmount, reinitialize if initialValues change
const ConnectedVehicleDetailsForm = reduxForm<FormProps, Props>({
  form: 'vehicleDetailForm',
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(VehicleDetailsForm)

const selector = formValueSelector('vehicleDetailForm')
const mapStateToProps = (state) => ({
  selectedTrimId: selector(state, 'selected_trim_id'),
})

export default connect(mapStateToProps, { updateSelectedTrim })(
  ConnectedVehicleDetailsForm
)
